Controller.$inject = ['$scope', '$element', '$timeout'];

function Controller($scope, $element, $timeout) {
    const self = this;
    self.hasExtraIcon = false;
    self.hasStartAddon =  false;
    self.hasEndAddon = false;
    self.hasIcon = false;
    self.selectedSwitcherOption = null;

    self.$onInit = () => {
        if (Array.isArray(self.switcherOptions) && self.switcherOptions.length) {
            self.selectedSwitcherOption = self.switcherOptions[0];
        }
    };

    self.$onChanges = (changes) => {
        if (changes.modelValue) {
            const currentValue = changes.modelValue.currentValue;
            if (Array.isArray(currentValue)) {
                self.modelValue = !!currentValue.length;
            } else {
                self.modelValue = currentValue !== null && currentValue !== undefined && currentValue !== '';
            }
        }
    };

    self.selectSwitcherOption = ($event) => {
        self.selectedSwitcherOption = $event;
        self.onSelectedSwitcherChange({$event});
    };

    self.stepDown = () => {
        self.onStepDown();
    };

    self.stepUp = () => {
        self.onStepUp();
    };

    const adjustLegendWidth = () => {
        const labelElement = $element[0].querySelector('.hui-input-label');
        const legendElement = $element[0].querySelector('.hui-input-legend');
        const baseLabelElement = $element[0].querySelector('.hui-input-label hui-input-base-label');
        const isEmpty = !!baseLabelElement.innerHTML.trim();
        if (labelElement && legendElement) {
            legendElement.innerHTML = labelElement.innerHTML;
        }

        if (!isEmpty) {
            angular.element(labelElement).css('display', 'none');
        } else {
            angular.element(labelElement).css('display', 'inline-flex');
        }
    };

    const checkForExtraIcon = () => {
        const startIconTransclusion = $element[0].querySelector('.hui-input-start-icon hui-input-start-icon');
        const hasStartIcon = startIconTransclusion && startIconTransclusion.innerHTML.trim() !== '';

        if (hasStartIcon) {
            self.hasExtraIcon = true;
        }
    };

    const checkForInputIcon = () => {
        const inputIconTransclusion = $element[0].querySelector('.hui-input-icon hui-input-base-icon');
        const hasIcon = inputIconTransclusion && inputIconTransclusion.innerHTML.trim() !== '';

        if (hasIcon) {
            self.hasIcon = true;
        }
    };

    const checkForAddons = () => {
        const startAddonElement = $element[0].querySelector('hui-input-base-start-addon hui-input-addon-start');
        const endAddonElement = $element[0].querySelector('hui-input-base-end-addon hui-input-addon-end');

        self.hasStartAddon = !!startAddonElement;
        self.hasEndAddon = !!endAddonElement;

        if (self.addonSize === 'sm' && (self.hasStartAddon || self.hasEndAddon)) {
            const addonStartWidth = self.hasStartAddon ? startAddonElement.getBoundingClientRect().width : 0;
            const addonEndWidth = this.hasEndAddon ? endAddonElement.getBoundingClientRect().width : 0;
            const inputElement = $element[0].querySelector('.hui-base-input');
            const labelElement = $element[0].querySelector('.hui-input-label');
            if (inputElement) {
                let updatedStyles = inputElement.getAttribute('style') || '';
                let labelUpdatedStyles = labelElement.getAttribute('style') || '';

                if (addonStartWidth) {
                    updatedStyles += `padding-inline-start: ${addonStartWidth + 3}px !important; `;
                }

                if (self.labelVariant === 'outlined') {
                    labelUpdatedStyles += `left: ${(addonStartWidth ? (addonStartWidth + 4) : 8)}px`;
                }

                if (addonEndWidth) {
                    updatedStyles += `padding-inline-end: ${addonEndWidth + 3}px !important; `;
                }

                inputElement.setAttribute('style', updatedStyles);
                labelElement.setAttribute('style', labelUpdatedStyles);
            }
        }
    };

    self.$postLink = () => {
        $timeout(()=>{
            adjustLegendWidth();
            checkForInputIcon();
            checkForExtraIcon();
            checkForAddons();
        },0);
    };
}

export function HuiInputBase() {
    return {
        restrict: 'E',
        replace: true,
        bindToController: {
            labelVariant: '@',
            iconPosition: '@',
            hasError: '<',
            modelValue: '<',
            disabled: '<',
            showLegend: '<',
            inputFocused: '<',
            fullWidth: '<',
            fullHeight: '<',
            addonSize: '<?',
            stepperPosition: '@',
            onStepUp: '&',
            onStepDown: '&',
            textarea:'<',
            withIconStart: '<?',
            switcherOptions: '<?',
            onSelectedSwitcherChange: '&',
        },
        controller: Controller,
        controllerAs: '$huiInputCtrl',
        transclude: {
            'label': '?huiInputBaseLabel',
            'icon': '?huiInputBaseIcon',
            'startIcon': '?huiInputStartIcon',
            'startAddon': '?huiInputBaseStartAddon',
            'endAddon': '?huiInputBaseEndAddon',
        },
        template: `
            <div class="hui hui-input"
                 ng-class="{
                    'hui-input-base-top': $huiInputCtrl.labelVariant === 'top',
                    'hui-input-base-inline': $huiInputCtrl.labelVariant === 'inline',
                    'with-icon-start': ($huiInputCtrl.hasIcon && $huiInputCtrl.iconPosition === 'start') || $huiInputCtrl.hasExtraIcon || $huiInputCtrl.withIconStart,
                    'hui-input-top': $huiInputCtrl.labelVariant === 'top',
                    'hui-input-inline': $huiInputCtrl.labelVariant === 'inline',
                    'hui-input-outlined': $huiInputCtrl.labelVariant === 'outlined',
                    'with-icon-end': ($huiInputCtrl.hasIcon && $huiInputCtrl.iconPosition === 'end'),
                    'has-error': $huiInputCtrl.hasError,
                    'focused': $huiInputCtrl.labelVariant === 'outlined' && ($huiInputCtrl.showLegend || $huiInputCtrl.modelValue || $huiInputCtrl.inputFocused),
                    'w-100': $huiInputCtrl.fullWidth,
                    'h-100': $huiInputCtrl.fullHeight,
                    'with-addon-start': $huiInputCtrl.hasStartAddon,
                    'with-addon-end': $huiInputCtrl.hasEndAddon,
                    'sm-addon': $huiInputCtrl.addonSize === 'sm',
                    'hui-input-textarea' : $huiInputCtrl.textarea,
                 }">
                 
                <label class="hui-input-label label-{{ $huiInputCtrl.labelVariant }}"
                       ng-transclude="label"
                       ng-class="{
                           'with-icon': ($huiInputCtrl.hasIcon && $huiInputCtrl.iconPosition === 'start') || $huiInputCtrl.hasExtraIcon,
                           'focused': $huiInputCtrl.showLegend || $huiInputCtrl.modelValue || $huiInputCtrl.inputFocused,
                           'with-addon-start': $huiInputCtrl.hasStartAddon,
                           'with-addon-end': $huiInputCtrl.hasEndAddon,
                          ' with-range-selector': $huiInputCtrl.stepperPosition === 'range' && $huiInputCtrl.labelVariant === 'outlined'
                       }">
                </label>
                <div class="hui-input-base-wrapper" ng-class="{'h-100': $huiInputCtrl.fullHeight, 'with-addon-start': $huiInputCtrl.hasStartAddon, 
                                                               'with-addon-end': $huiInputCtrl.hasEndAddon,'hide-default-spinner' : !!$huiInputCtrl.stepperPosition,
                                                               'range-spinner': $huiInputCtrl.stepperPosition === 'range'}">
                    <span ng-transclude="startIcon" class="hui-input-start-icon"></span>
                    <div ng-transclude="startAddon" class="hui-input-addon addon-start" ng-class="{'disabled-addon': $huiInputCtrl.disabled, 'd-none': !$huiInputCtrl.hasStartAddon}"></div>
                    <div ng-transclude="endAddon" class="hui-input-addon addon-end" ng-class="{'disabled-addon': $huiInputCtrl.disabled, 'd-none': !$huiInputCtrl.hasEndAddon}"></div>
                    
                    <span class="hui-input-icon"
                          ng-transclude="icon"
                          ng-class="{'icon-end': $huiInputCtrl.iconPosition === 'end'}">
                    </span>
                    <div ng-if="$huiInputCtrl.stepperPosition === 'end'" class="inline-selectors">
                        <button class="selector-button"
                                ng-class="{'disabled-btn': $huiInputCtrl.disabled}"
                                ng-click="$huiInputCtrl.stepDown()">
                            <i class="fa-solid fa-minus"></i>
                        </button>
                        <div class="hui-line-separator"></div>
                        <button class="selector-button"
                                ng-class="{'disabled-btn': $huiInputCtrl.disabled}"
                                ng-click="$huiInputCtrl.stepUp()">
                            <i class="fa-solid fa-plus"></i>
                        </button>
                   </div>
                   
                   <div ng-if="$huiInputCtrl.stepperPosition === 'range'">
                        <button  class="selector-button range-button minus-selector-button"
                                ng-class="{'disabled-btn': $huiInputCtrl.disabled}" 
                                ng-click="$huiInputCtrl.stepDown()">
                            <i class="fa-solid fa-minus"></i>
                        </button>
                        <button class="selector-button range-button plus-selector-button"
                                ng-class="{'disabled-btn': $huiInputCtrl.disabled}" 
                                ng-click="$huiInputCtrl.stepUp()">
                            <i class="fa-solid fa-plus"></i>
                        </button>
                    </div>
                    
                    <div ng-if="$huiInputCtrl.switcherOptions.length"
                         class="switcher-toggle-group">
                        <button tabindex="-1"
                                automation="switcherOption"
                                ng-repeat="option in $huiInputCtrl.switcherOptions"
                                ng-class="{'disabled-btn': $huiInputCtrl.disabled,
                                            'active': option === $huiInputCtrl.selectedSwitcherOption}"
                                ng-click="$huiInputCtrl.selectSwitcherOption(option)">
                            {{ option }}
                        </button>
                    </div>
            
                    <ng-transclude ng-class="{'w-100':$huiInputCtrl.fullWidth}" class="d-inline-flex"></ng-transclude>
                    <fieldset ng-show="$huiInputCtrl.labelVariant === 'outlined'"
                              class="hui-input-fieldset {{$huiInputCtrl.showLegend}}"
                              ng-class="{
                                  'has-legend': $huiInputCtrl.showLegend || $huiInputCtrl.modelValue,
                                  'focused': $huiInputCtrl.inputFocused,
                                  'has-error': (($huiInputCtrl.showLegend || $huiInputCtrl.modelValue) && $huiInputCtrl.hasError)
                              }">
                        <legend class="hui-input-legend focused"
                                ng-class="{'d-none': !$huiInputCtrl.showLegend && !$huiInputCtrl.modelValue && !$huiInputCtrl.inputFocused}">
                                &nbsp;
                        </legend>
                    </fieldset>
                </div>
            </div>`
    };
}
